import React, { useRef } from 'react';
import { Tooltip } from 'antd';
import cn from 'classnames';
import { useResizeObserverState } from '../../hooks/useResizeObserverState';
import styles from './EllipsisTextWithTooltip.module.scss';

const EllipsisTextWithTooltip = ({
  as = 'span',
  tooltipTitle,
  tooltipProps = null,
  children,
  className,
  ...props
}) => {
  const Component = as;

  const ref = useRef();

  const hasOverflow = useResizeObserverState(ref, {
    compute: (el) => el?.offsetWidth < el?.scrollWidth,
    defaultValue: false,
  });

  const _tooltipTitle = hasOverflow ? tooltipTitle : undefined;

  return (
    <Tooltip {...tooltipProps} title={_tooltipTitle}>
      <Component {...props} className={cn(styles.root, className)} ref={ref}>
        {children}
      </Component>
    </Tooltip>
  );
};

export default EllipsisTextWithTooltip;
